import React, { memo } from 'react';
import { colors, distances } from '../../../styles/constants';
import { H3 } from '../../../components/Typography';
import Icon from '../../../components/Icons';

import styled from 'styled-components/macro';

export enum StepState {
    Pending = 'pending',
    Active = 'active',
    Done = 'done',
}

interface StateFilterProps {
    step: number;
    title: string;
    current: number;
}

const getState = (step: number, current: number) => {
    if (step === current) {
        return StepState.Active;
    }
    return step < current ? StepState.Done : StepState.Pending;
};

const StepHeader = (
    {
        step,
        title,
        current,
    }: StateFilterProps
) => {
    const state = getState(step, current);
    return (
        <Wrapper className={state === StepState.Done ? 'done' : ''}>
            <Step state={state}>{step}</Step>
            <Title state={state}>{title}</Title>
            {state === StepState.Done && (
                <IconWrap>
                    <Icon icon="check" />
                </IconWrap>
            )}
        </Wrapper>
    );
};

export default memo(StepHeader);

const Wrapper = styled.div`
    display: flex;
    align-items: center;

    &.done > div {
        &::after {
            content: ' ';
            position: absolute;
            top: calc(50% - 0px);
            left: 5px;
            right: -17px;
            height: 1px;
            background: ${colors.primary};
        }
    }
    &.done > h2 {
        position: relative;
        &::after {
            content: ' ';
            position: absolute;
            top: calc(50% - 0px);
            left: 0;
            right: -3px;
            height: 1px;
            background: ${colors.primary};
        }
    }
`;

interface StyledStep {
    state: StepState;
}

const getColor = (state: StepState) => {
    if (state === StepState.Active) {
        return colors.primary;
    }
    return colors.borderDark;
};

const getBgColor = (state: StepState) => {
    if (state === StepState.Active) {
        return colors.primary;
    }
    if (state === StepState.Done) {
        return colors.borderLight;
    }
    return colors.background;
};

const Step = styled.div<StyledStep>`
    border-radius: 26px;
    height: 26px;
    width: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${props => getBgColor(props.state)};
    color: ${colors.background};
    font-size: ${distances.small};
    font-weight: 800;
    margin-right: ${distances.small};
    position: relative;

    ${props =>
        props.state === StepState.Pending
            ? `
        border: thin solid ${colors.borderLight};
        color: ${colors.borderDark};
            `
            : ''};
`;

const Title = styled(H3)<StyledStep>`
    color: ${props => getColor(props.state)};
    /* text-decoration: ${props => (props.state === StepState.Done ? 'line-through' : 'none')}; */
`;
const IconWrap = styled.span`
    margin-left: 10px;
`;
